import React, { useState } from 'react'
import Tag from './../../components/Tag/Tag'

import {
  CardActionArea,
  Dialog,
  Grid,
  CardMedia,
  CardContent,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import Card from '@mui/material/Card'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import './Portfolio.css'
import { PortfolioData } from './../../utils/PortfolioData'
import Button from '@mui/material/Button'

const Portfolio = () => {
  const [dialog, setDialog] = useState(false)
  const FolioDiaglog = () => {
    const folioBtn ={
      color:'whitesmoke'
    }
    return (
      <Dialog open={dialog} onClose={() => setDialog(false)}>
        <DialogActions className='log-x'>
          <HighlightOffIcon onClick={() => setDialog(false)} />
        </DialogActions>
        <DialogTitle onClose={() => setDialog(false)} className='log-title'>
          {dialog.title}
        </DialogTitle>
        <img src={dialog.projectImg} alt='project display' />
        <DialogContent>{dialog.description}</DialogContent>
        <div className='app-link'>
          <a
            href={dialog.gitLink}
            target='_blank'
            rel='noreferrer'
            id='git-icon'
          >
            <Button sx={folioBtn}>
              {'GitHub'}
              {dialog.gitIcon}
            </Button>
          </a>
          <a
            href={dialog.website}
            target='_blank'
            rel='noreferrer'
            id='app-link'
          >
            <Button sx={folioBtn}>
              {' Lauch App'} {dialog.linkIcon}
            </Button>
          </a>
        </div>
      </Dialog>
    )
  }
  return (
    <div>
      <Tag tagName='portfolio' />
      <div className='stack-margin'>
        <Grid container spacing={2}>
          <FolioDiaglog />
          {PortfolioData.map((data, id = 1) => {
            return (
              <Grid
                key={id++}
                item
                xs={12}
                sm={12}
                md={4}
                onClick={() => setDialog(data)}
              >
                <Card className='project-card'>
                  <CardActionArea>
                    <CardMedia
                      className='project-img'
                      title='project image'
                      image={data.projectImg}
                    />
                    <CardContent>
                      <h6>{data.title}</h6>
                      <p>{data.caption}</p>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </div>
    </div>
  )
}

export default Portfolio
